<template>
  <base-card class="w-90 ms-2 mb-1 gray-make-sell-card-background" v-if="shouldShowApplicationNavbarCard === true">
    <div class="hover-side-nav-link-bg d-flex align-items-center">
      <div class="icon-container">
        <i :class="salesLink.icon"></i>
      </div>
      <span class="name-of-link">
        {{ salesLink.text }}
      </span>
    </div>
    <div class="d-flex flex-column align-items-center mt-2">
      <div class="d-flex w-100">
        <base-button
          item-class="btn-primary btn-md d-flex justify-content-between align-items-center w-100 tarfin-application-button fw-normal"
          @click="clickToTarfinApplicationCreate(salesLink.name)"
        >
          <div class="d-flex">
            {{ t('views.layouts.tarfin_application_create') }}
          </div>
          <div class="d-flex pe-0 chevron-icon">
            <i class="mdi mdi-chevron-right text-white mdi-20px" />
          </div>
        </base-button>
      </div>
      <div class="d-flex w-100 mt-2" v-if="country.isNot('ro') && fibaSalesChannelStatus">
        <div class="btn-group dropend w-100">
          <button
            type="button"
            class="other-channel-button fw-normal btn btn-outline-secondary justify-content-between align-items-center d-flex w-100 text-secondarydropdown-toggle"
            data-bs-toggle="dropdown"
            data-bs-boundary="window"
            aria-expanded="false"
          >
            <div class="d-flex">
              {{ t('views.layouts.other_sales_channels') }}
            </div>
            <div class="d-flex other-channel-icon">
              <i class="mdi mdi-menu-right text-secondary mdi-24px sales-channel-icon"></i>
            </div>
          </button>
          <ul class="dropdown-menu fiba-channel-button">
            <base-button
              item-class="toggle-channel-button btn-outline-secondary justify-content-between align-items-center d-flex w-100 text-secondary"
              @click="clickToFibaApplicationCreate(salesLink.child[0].name)"
            >
              <span class="showing-button-text">Fibabanka Başvurusu</span></base-button
            >
          </ul>
        </div>
      </div>
    </div>
  </base-card>
  <template v-else>
    <ul class="side-nav side-nav-light mb-0">
      <li class="side-nav-item fixed-button">
        <div class="btn-group">
          <button
            class="side-nav-link side-nav-link-sale-specific d-flex text-decoration-none justify-content-between btn btn-outline-secondary"
            data-bs-toggle="dropdown"
            data-bs-boundary="window"
            aria-expanded="false"
          >
            <div class="d-flex align-items-center">
              <div class="icon-container">
                <i class="mdi mdi-cart me-0 sale-specific-icons"></i>
                <i class="mdi mdi-chevron-right ms-0 sale-specific-icons" />
              </div>
            </div>
          </button>
          <ul class="dropdown-menu fiba-channel-button-wrapper">
            <div class="d-flex flex-column">
              <div
                class="d-flex justify-content-start align-items-center"
                :class="{
                  'fiba-channel-button-wrapper-first': fibaSalesChannelStatus
                }"
              >
                <div class="d-flex align-items-center">
                  <i
                    class="mdi mdi-cart me-0 ms-2"
                    :class="{ 'tarfin-application-icon': isMouseOverTarfinApplicationButton === true }"
                  ></i>
                </div>
                <div class="d-flex align-items-center me-auto">
                  <base-button
                    item-class="toggle-channel-button-2 btn-outline-secondary justify-content-between align-items-center d-flex w-100 text-secondary"
                    @click="clickToTarfinApplicationCreate(salesLink.name)"
                    @mouseover="hoverTarfinApplicationButton"
                    @mouseleave="notHoverTarfinApplicationButton"
                  >
                    <span class="showing-button-text-2">{{
                      t('views.layouts.tarfin_application_create')
                    }}</span></base-button
                  >
                </div>
              </div>
              <div
                class="d-flex justify-content-start align-items-center"
                v-if="country.isNot('ro') && fibaSalesChannelStatus"
              >
                <div class="d-flex align-items-center">
                  <i
                    class="mdi mdi-bank me-0 ms-2"
                    :class="{ 'fiba-application-icon': isMouseOverFibaApplicationButton === true }"
                  ></i>
                </div>
                <div class="d-flex align-items-center me-auto">
                  <base-button
                    item-class="toggle-channel-button-3 btn-outline-secondary justify-content-between align-items-center d-flex w-100 text-secondary"
                    @click="clickToFibaApplicationCreate(salesLink.child[0].name)"
                    @mouseover="hoverFibaApplicationButton"
                    @mouseleave="notHoverFibaApplicationButton"
                  >
                    <span class="showing-button-text-3">Fibabanka Başvurusu</span>
                  </base-button>
                </div>
              </div>
            </div>
          </ul>
        </div>
      </li>
    </ul>
  </template>
</template>

<script setup>
import { ref, onBeforeMount, computed, watch, onMounted, onBeforeUnmount } from 'vue'

import { useStore } from 'vuex'

import { event } from 'vue-gtag'

import { useI18n } from 'vue-i18n'

import { useRouter } from 'vue-router'

import country from '@/utilities/country.js'

import BaseButton from '@/components/BaseButton.vue'
import BaseCard from '@/components/BaseCard.vue'

// #region - i18n set
const { t } = useI18n()
// endregion

// #region - Vuex state
const store = useStore()
// endregion

// #region - references
const salesLink = ref({
  text: t('views.layouts.sale'),
  icon: 'mdi mdi-cart',
  name: 'retailer.dashboard'
})

const isMouseOverTarfinApplicationButton = ref(false)
const isMouseOverFibaApplicationButton = ref(false)
const shouldShowApplicationNavbarCard = ref(true)
const ignoreFirstShowValue = ref(true)
// endregion

// #region - observer for document body watch
let observer = null
// endregion

// #region - router set
const router = useRouter()
// endregion

// #region - lifecycle hooks
onBeforeMount(() => {
  if (country.isNot('ro')) {
    salesLink.value = {
      text: t('views.layouts.sale'),
      icon: 'mdi mdi-cart',
      name: 'retailer.application.create',
      child: [
        {
          text: 'Fibabanka Başvuru',
          name: 'retailer.applications.fibabank.create'
        }
      ]
    }
  } else {
    salesLink.value = {
      text: t('views.layouts.sale'),
      icon: 'mdi mdi-cart',
      name: 'ro.retailer.applications.create'
    }
  }
})
// endregion

// #region - onMounted lifecycle hook
onMounted(() => {
  updateScrollableBodyMode()

  observer = new MutationObserver(() => {
    updateScrollableBodyMode()
  })

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-leftbar-compact-mode']
  })
})
// endregion

// #region - onMounted lifecycle hook
onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect()
  }
})
// endregion

// #region - computed properties
const isSidebarActive = computed(() => {
  return store.state.sideMenu.sidebarActive
})

const fibaSalesChannelStatus = computed(() => store.getters['retailerAuth/fibaSalesChannelStatus'])
// endregion

// #region - method definitions
const updateScrollableBodyMode = () => {
  shouldShowApplicationNavbarCard.value = document.body.getAttribute('data-leftbar-compact-mode') === 'scrollable'
}

const clickToTarfinApplicationCreate = name => {
  store.commit('sideMenu/SET_ACTIVE_MENU_INDEX', null)

  event('application_menu_click')
  router.push({
    name: name
  })
}

const clickToFibaApplicationCreate = name => {
  store.commit('sideMenu/SET_ACTIVE_MENU_INDEX', null)

  event('application_menu_click')
  router.push({
    name: name
  })
}

const hoverTarfinApplicationButton = () => {
  isMouseOverTarfinApplicationButton.value = true
}

const notHoverTarfinApplicationButton = () => {
  isMouseOverTarfinApplicationButton.value = false
}

const hoverFibaApplicationButton = () => {
  isMouseOverFibaApplicationButton.value = true
}

const notHoverFibaApplicationButton = () => {
  isMouseOverFibaApplicationButton.value = false
}
// endregion

// #region - watch part
watch(
  () => isSidebarActive.value,
  (newVal, oldVal) => {
    if (ignoreFirstShowValue.value === true) {
      ignoreFirstShowValue.value = false
      return
    }
    shouldShowApplicationNavbarCard.value = newVal
  }
)
// endregion
</script>

<style lang="scss">
.gray-make-sell-card-background {
  > .card-body {
    padding: 1rem;
  }
}
</style>

<style lang="scss" scoped>
.gray-make-sell-card-background {
  background-color: #f0f0f1;
  margin-top: 0.5rem;

  > .card-body {
    padding: 1rem;
  }
}

.w-90 {
  width: 90%;
}

.fixed-button {
  height: 38px;
  > .btn-group {
    width: 85%;
  }
}

.icon-container {
  position: relative;
  display: inline-block;
}

.name-of-link {
  margin-left: 0.889rem;
  vertical-align: middle;
}

.fiba-channel-button {
  height: 44px !important;
  padding-top: 0px;
  border-style: none;
  border-width: 0;
  transform: translate(195px, -3px) !important;

  @media (max-width: 768px) {
    transform: translate3d(195px, 0px, 0px) !important;
    left: -195px !important;
    top: 42px !important;
    width: 190px;
  }

  &:hover {
    .showing-button-text {
      color: $primary;
    }
  }
}

.fiba-channel-button-wrapper {
  background-color: $white;
  border-style: none;
  border-width: 0;
  transform: translate(75px, 5px) !important;
  box-shadow: 1px 1px 35px rgba(154, 161, 171, 0.15) !important;

  &-first {
    border-bottom: 1px solid #eaebeb;
  }
}

.toggle-channel-button-2 {
  background-color: $white;
  height: 40px;
  font-weight: 400;
  font-size: 13.22px;
  border-style: none;
  border: none;
  &:hover {
    background-color: $white;
    .showing-button-text-2 {
      color: $primary;
    }
  }
}

.toggle-channel-button-3 {
  background-color: $white;
  height: 40px;
  font-weight: 400;
  font-size: 13.22px;
  border-style: none;
  border: none;
  &:hover {
    background-color: $white;
    .showing-button-text-3 {
      color: $primary;
    }
  }
}

.tarfin-application-icon {
  color: $primary;
}

.fiba-application-icon {
  color: $primary;
}

.other-channel-button {
  background-color: #f0f0f1;
  border-color: #cfcfcf !important;
  height: 40px;
  border-width: 1.2px;
  border-radius: 6px !important;

  &:focus {
    background-color: #f0f0f1;
    color: $primary !important;
    .sales-channel-icon {
      color: $primary !important;
    }
  }

  &:hover {
    background-color: #f0f0f1;
    color: $primary !important;

    .sales-channel-icon {
      color: $primary !important;
    }
  }

  .showing-button-text {
    margin-left: 0.189rem;
    font-weight: 400;
    font-size: 13.22px;
  }
}

.toggle-channel-button {
  height: 40px;
  font-weight: 400;
  font-size: 13.22px;
  border-style: none;
  border: none;
  box-shadow: 0px 0px 35px rgba(154, 161, 171, 0.15) !important;
}

.tarfin-application-button {
  &:hover {
    background-color: #28863c;
    color: white !important;
  }
}
</style>
